<template>
    <div ref="donutElement" class="donut-container">
        <div class="donut"></div>
        <div class="outer-circle"></div>
        <div class="inner-circle" v-html="text.replace('{0}', counter)"></div>
        <div v-if="isLine" class="line" v-for="(r, index) in 16" :key="r" :style="{ 'transform': `translate(-50%, -50%) rotate(${(index * 360) / 16}deg)` }">
        </div>
    </div>
</template>

<script>
export default {
    emits: ["tick"],
    props: {
        value: {
            type: Number,
            required: true
        },
        isLine: {
            type: Boolean,
            default: false
        },
        emptyColor: {
            default: "#D9D6EA"
        },
        fillColor: {
            default: "#59BDEF"
        },
        size: {
            default: "10rem"
        },
        strong: {
            default: "4rem"
        },
        lineSize: {
            default: "3px"
        },
        lineColor: {
            default: "#FFF"
        },
        fontColor: {
            default: "#000"
        },
        fontSize: {
            default: "1.2rem"
        },
        text: {
            default: "%{0}"
        },
    },
    data() {
        return {
            reinit: false,
            counter: 0,
            interval: null,
        };
    },
    mounted() {
        this.setDonut(0);
        this.load();
    },
    methods: {
        load() {
            const _this = this;
            
            const tick = 750.0 / (_this.value <= 0 ? 1 : _this.value);
            _this.counter = 0;

            if (_this.interval) {
                clearInterval(_this.interval);
            }

            _this.reinit = false;

            _this.$nextTick(() => {                
                _this.setDonut(0);
                _this.interval = setInterval(function () {
                    _this.$emit("tick");
                    if (_this.counter < _this.value) {
                        _this.counter++;
                        _this.setDonut(_this.counter);
                    }
                    else {
                        clearInterval(_this.interval);
                    }
                }, tick);
                _this.reinit = true;
            });
        },
        setDonut(val) {
            if (this.$refs.donutElement) {
                this.$refs.donutElement.style.setProperty('--percentage-donut-chart', val);
            }
        }
    },
    watch: {
        value: function (n, o) {
            this.load();
        }
    },
};
</script>

<style scoped>

    :root {
        --angle-donut-chart: 0deg;
    }
    .donut-container {
        position: relative;
        width: v-bind('size');
        height: v-bind('size');
        min-width: v-bind('size');
        min-height: v-bind('size');
    }

    .donut {
        position: absolute;
        top: 50%;
        left: 50%;
        width: v-bind('size');
        height: v-bind('size');
        border: calc(v-bind('strong') / 2) solid #E2E8F0;;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
    }

    .outer-circle {
        position: absolute;
        top: 50%;
        left: 50%;
        width: v-bind('size');
        height: v-bind('size');
        border-radius: 50%;
        /*background: conic-gradient(#59bdef var(--angle-donut-chart), transparent 0% 100%); */
        background: conic-gradient(#59bdef, #3955a3, #a35fc1 var(--angle-donut-chart), transparent 0% 100%);
        transform: translate(-50%, -50%);
        z-index: 1; /* outer-circle ortada */
        animation: conic-effect 3s ease-in-out forwards; /*forwards*/
    }

    .inner-circle {
        position: absolute;
        top: 50%;
        left: 50%;
        width: calc(v-bind('size') - v-bind('strong'));
        height: calc(v-bind('size') - v-bind('strong'));
        background-color: #fff;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: v-bind('fontColor');
        font-size: v-bind('fontSize');
        line-height: 1;
        text-align: center;
        z-index: 999;
    }

    .line {
        position: absolute;
        top: 50%;
        left: 50%;
        width: v-bind('size');
        /*height: v-bind('lineSize');*/
        height: 0px;
        background-color: v-bind('lineColor');
        z-index: 3;
        
    }

    
    @property --angle-donut-chart {
        syntax: "<angle>";
        inherits: false;
        initial-value: 0deg;
    }
    @keyframes conic-effect {
        0% {
            --angle-donut-chart: -1deg;
        }
        1% {
            --angle-donut-chart: 0deg;
        }
        100% {
            --angle-donut-chart: calc(3.6deg * var(--percentage-donut-chart));
        }
    }
</style>
